/** Normalize Mongo/Redis ids for reliable equality checks. */
export function idStr(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'object' && value.$oid) return String(value.$oid);
  return String(value);
}

export function idsEqual(a, b) {
  const left = idStr(a);
  const right = idStr(b);
  return Boolean(left) && left === right;
}

export function findById(list, id) {
  if (!Array.isArray(list) || id == null || id === '') return undefined;
  const target = idStr(id);
  return list.find((item) => idsEqual(item?._id ?? item?.id, target));
}

/**
 * Filter catalog games to those assigned on a parent entity (admin/superStokez/etc).
 * Returns [] when assignedIds is missing/empty (caller may choose a fallback).
 */
export function filterGamesByAssignedIds(games, assignedIds) {
  if (!Array.isArray(games) || !games.length) return [];
  if (!Array.isArray(assignedIds) || !assignedIds.length) return [];
  const allowed = new Set(assignedIds.map(idStr).filter(Boolean));
  return games.filter((g) => allowed.has(idStr(g._id ?? g.id)));
}
